import { __read } from "tslib";
export var setChartSettings = function (_a) {
    var keys = _a.keys;
    var _b = __read(keys, 1), valueKey = _b[0];
    return {
        valueKey: valueKey,
    };
};
